// ListView.vue
<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useItems } from '@/composables/useItems'

export default defineComponent({
  setup() {
    // Call the composable to get items
    const { items, fetchItems } = useItems()

    // Fetch items when the component is mounted
    onMounted(() => {
      fetchItems()
    })

    // Expose to template and other options API hooks
    return {
      items
    }
  }
})
</script>

<template>
  <div>
    <ul>
      <li v-for="item in items" :key="item.id">
        {{ item.name }}
      </li>
      <li v-if="items.length === 0">No items found</li>
    </ul>
  </div>
</template>
